//---------------------------------------
//			 ファイルのUPLOAD
//---------------------------------------
function dnd_file_upload(e,obj)
{
	//D&Dされたファイルを取得
	file = e.originalEvent.dataTransfer.files[0];
	if (file.type.indexOf('image/jpeg') !== 0) {
		alert('Jpeg画像のみ受付可能です');
		return;
	}

	// ファイルを上げに行く  
	var fd= new FormData();  
	fd.append("userfile", file);	

	//D&Dされた画像のファイル名
	upload_filename = obj.attr('src')
	if(obj.data('filename')){
		upload_filename = obj.data('filename');
	}

	//画像ファイルを更新するために?の後ろにランダム値をつけるが、そうすると
	//次の画像ファイル名が?付きになるのでそれを切る
	var res = upload_filename.split("?");
	upload_filename = res[0];

	fd.append('upload_filename', upload_filename);	

	$.ajax({	
			url: "https://www.tirakita.com/syssyssyssyssyssyssyssyssyssys/HP_Make/dnd_file_upload.php",	
			type: "POST",  
			contentType: false,  
			processData: false,  
			cache: false,  
			data: fd,  
			success: function(data) {  
				obj.attr("src",upload_filename+"?"+ new Date().getTime());
			},	
			error: function(data) {  
				 alert(data);  
			}  
	});  
}


$(function(){  
		$(".DnD").on('dragenter', function (e) {	
				e.stopPropagation();	
				e.preventDefault();  
				$(this).css('border', '1px dotted #000');	
		});  
		$(".DnD").on('dragover', function (e) {  
				e.stopPropagation();	
				e.preventDefault();  
				$(this).css('border', '1px dotted #000');	
		});  
		$(".DnD").on('drop', function (e) {  
				$(this).css('border', '1px dashed #000');  
				e.preventDefault();  
				dnd_file_upload(e,$(this));
		});  
		$(".DnD").on('dragleave', function (e) {	
				$(this).css('border', '0px');	
		});  
});  
